import { Action } from 'redux';
import {
    LandingPage,
    Newsletter,
    NewsletterStatusEnum,
    SimpleNewsletter,
    Template,
} from '@dev/ee-api/ee-api-models';
import { GetPaidNewslettersParams } from '@/services/ApiCategories/paidNewsletters';

export type PaidNewslettersListItem = SimpleNewsletter & {
    isChangingStatus?: boolean
};
export interface PaidNewsletterListState {
    loadingTemplates?: boolean;
    loadingTemplate?: boolean;
    templatesList?: PaidNewslettersListItem[];
    count?: number;
    updatingTemplate?: boolean;
    deletingTemplate?: boolean;
    previewLoading?: boolean;
    templateSaving?: boolean;
    name?: string;
    template?: SimpleNewsletter;
    templateObject?: SimpleNewsletter;
    paidNewsletter?: LandingPage;
    checkedPaidNewsletters?: string[];
    isPublic?: boolean;
    removeScreenshot?: boolean;
    prevTemplateName?: string;
    changes?: Template;
    publishedCount?: number;
    unpublishedCount?: number;
}

export interface StdLoadListInterface extends GetPaidNewslettersParams, GetPaidNewslettersParams {
    isUrlUpdateDisabled?: boolean
}

export interface UrlSearchParams {
    page?: number;
    perPage?: number;
    search?: string;
    from?: string;
    to?: string;
    status?: [];
}

export enum PaidNewslettersActionTypes {
    GET_ALL_PAID_NEWSLETTERS_START = '@@paidNewsletters/GET_ALL_PAID_NEWSLETTERS_START',
    GET_ALL_PAID_NEWSLETTERS_SUCCESS = '@@paidNewsletters/GET_ALL_PAID_NEWSLETTERS_SUCCESS',
    GET_ALL_PAID_NEWSLETTERS_ERROR = '@@paidNewsletters/GET_ALL_PAID_NEWSLETTERS_ERROR',
    GET_PAID_NEWSLETTER_BY_NAME_START = '@@paidNewsletters/GET_PAID_NEWSLETTER_BY_NAME_START',
    GET_PAID_NEWSLETTER_BY_NAME_SUCCESS = '@@paidNewsletters/GET_PAID_NEWSLETTER_BY_NAME_SUCCESS',
    GET_PAID_NEWSLETTER_BY_NAME_ERROR = '@@paidNewsletters/GET_PAID_NEWSLETTER_BY_NAME_ERROR',
    DELETE_PAID_NEWSLETTERS = '@@paidNewsletters/DELETE_PAID_NEWSLETTERS',
    DELETE_PAID_NEWSLETTERS_SUCCESS = '@@paidNewsletters/DELETE_PAID_NEWSLETTERS_SUCCESS',
    DELETE_PAID_NEWSLETTERS_ERROR = '@@paidNewsletters/DELETE_PAID_NEWSLETTERS_ERROR',
    PICK_PAID_NEWSLETTERS = '@@paidNewsletters/PICK_PAID_NEWSLETTERS',
    UNPICK_PAID_NEWSLETTERS = '@@paidNewsletters/UNPICK_PAID_NEWSLETTERS',
    LOAD_PREVIEW_TEMPLATE = '@@paidNewsletters/LOAD_PREVIEW_TEMPLATE',
    LOAD_PREVIEW_TEMPLATE_SUCCESS = '@@paidNewsletters/LOAD_PREVIEW_TEMPLATE_SUCCESS',
    LOAD_PREVIEW_TEMPLATE_ERROR = '@@paidNewsletters/LOAD_PREVIEW_TEMPLATE_ERROR',
    CLEAR_PREVIEW_TEMPLATE = '@@paidNewsletters/CLEAR_PREVIEW_TEMPLATE',
    UPDATE_PAID_NEWSLETTER_STATUS ='@@paidNewsletters/UPDATE_PAID_NEWSLETTER_STATUS',
    UPDATE_PAID_NEWSLETTER_STATUS_SUCCESS = '@@paidNewsletters/UPDATE_PAID_NEWSLETTER_STATUS_SUCCESS',
    UPDATE_PAID_NEWSLETTER_STATUS_ERROR = '@@paidNewsletters/UPDATE_PAID_NEWSLETTER_STATUS_ERROR'
}

export interface GetAllPaidNewslettersStartAction extends Action {
    type: PaidNewslettersActionTypes.GET_ALL_PAID_NEWSLETTERS_START;
    payload: StdLoadListInterface;
}

export interface GetAllPaidNewslettersSuccessAction extends Action {
    type: PaidNewslettersActionTypes.GET_ALL_PAID_NEWSLETTERS_SUCCESS;
    payload: StdLoadListInterface;
}

export interface GetAllPaidNewslettersErrorAction extends Action {
    type: PaidNewslettersActionTypes.GET_ALL_PAID_NEWSLETTERS_ERROR;
    payload: StdLoadListInterface;
}

export interface DeletePaidNewsletterAction extends Action {
    type: PaidNewslettersActionTypes.DELETE_PAID_NEWSLETTERS;
    payload: {
        Names: string[];
        UrlParams: StdLoadListInterface;
    };
}

export interface DeletePaidNewsletterSuccessAction extends Action {
    type: PaidNewslettersActionTypes.DELETE_PAID_NEWSLETTERS_SUCCESS;
}
export interface DeletePaidNewsletterErrorAction extends Action {
    type: PaidNewslettersActionTypes.DELETE_PAID_NEWSLETTERS_ERROR;
}
export interface PickPaidNewslettersAction extends Action {
    type: PaidNewslettersActionTypes.PICK_PAID_NEWSLETTERS;
    payload: {
        checkedPaidNewsletters: string[];
    };
}
export interface UnpickAllPaidNewslettersAction extends Action {
    type: PaidNewslettersActionTypes.UNPICK_PAID_NEWSLETTERS;
}

export interface GetPaidNewsletterByNameStartAction extends Action {
    type: PaidNewslettersActionTypes.GET_PAID_NEWSLETTER_BY_NAME_START;
    payload: { name: string; isTemplateThumbnailsRequired?: boolean };
}

export interface GetPaidNewsletterByNameSuccessAction extends Action {
    type: PaidNewslettersActionTypes.GET_PAID_NEWSLETTER_BY_NAME_SUCCESS;
    payload: {
        singlePaidNewsletter: LandingPage;
    };
}

export interface GetPaidNewsletterByNameErrorAction extends Action {
    type: PaidNewslettersActionTypes.GET_PAID_NEWSLETTER_BY_NAME_ERROR;
}

export interface LoadPreviewTemplateAction extends Action {
    type: PaidNewslettersActionTypes.LOAD_PREVIEW_TEMPLATE;
    payload: {
        name: string;
        previewLoading: boolean;
    };
}

export interface LoadPreviewTemplateSuccessAction extends Action {
    type: PaidNewslettersActionTypes.LOAD_PREVIEW_TEMPLATE_SUCCESS;
    payload: {
        paidNewsletter: Newsletter;
        previewLoading: boolean;
    }
}

export interface LoadPreviewTemplateErrorAction extends Action {
    type: PaidNewslettersActionTypes.LOAD_PREVIEW_TEMPLATE_ERROR;
    payload: {
        previewLoading: boolean;
    }
}

export interface ClearPreviewTemplateAction extends Action {
    type: PaidNewslettersActionTypes.CLEAR_PREVIEW_TEMPLATE;
    payload: null;
}

export interface UpdatePaidNewsletterStatusStartAction extends Action {
    type: PaidNewslettersActionTypes.UPDATE_PAID_NEWSLETTER_STATUS;
    payload: {
        name: string;
        status: NewsletterStatusEnum;
    }
}
export interface UpdatePaidNewsletterStatusSuccessAction extends Action {
    type: PaidNewslettersActionTypes.UPDATE_PAID_NEWSLETTER_STATUS_SUCCESS;
    payload: {

        status: NewsletterStatusEnum;
        name: string;
    }
}
export interface UpdatePaidNewsletterStatusErrorAction extends Action {
    type: PaidNewslettersActionTypes.UPDATE_PAID_NEWSLETTER_STATUS_ERROR;
    payload: {
        name: string;
    }
}

export enum DropdownOptions {
    EditPaidNewsletter = 'edit',
    PaidNewsletterLink = 'link',
    SendCampaign = 'sendcampaign',
    Delete = 'delete',
}
